import { render, staticRenderFns } from "./UserGroupSelector.vue?vue&type=template&id=8ea29f82&scoped=true"
import script from "./UserGroupSelector.vue?vue&type=script&lang=js"
export * from "./UserGroupSelector.vue?vue&type=script&lang=js"
import style0 from "./UserGroupSelector.vue?vue&type=style&index=0&id=8ea29f82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea29f82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
